import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=736e5f20&scoped=true"
import script from "./ChatBot.vue?vue&type=script&lang=js"
export * from "./ChatBot.vue?vue&type=script&lang=js"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=736e5f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736e5f20",
  null
  
)

export default component.exports